import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { ObsService } from '../../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-ft-twins',
  templateUrl: './ft-twins.component.html',
  styleUrls: ['./ft-twins.component.scss'],
})
export class FtTwinsComponent implements OnInit {
  @Input() Patient_type;
  @Input() gender;
  @Input() AmnioticFluid;
  @Input() CervicalOs;
  @Input() Chorionicity;
  @Input() Amnionicity;
  @Input() Grade;
  @Input() PlacentaLocation;
  @Input() PlacentaLocationAnatomic;
  @Input() Presentation;
  @Input() FetalAnomaly;
  @Input() NoofFetus;
  @Input() TechnicalConditions;
  @Input() FetalHeartBeat;
  @Input() image1;
  @Input() image2;
  @Input() disable;

  mode = 'first';
  repeat = false;
  trimister = false;
  copy = false;
  isLoading = false;
  response: any = [];
  result_id;
  form: FormGroup;
  patient;
  FetchPatient;
  drs: any = [];
  firstPic;
  firstPic2;
  fullImage;
  fullImage2;
  result: any = [];
  disabled: boolean = true;
  disabled2: boolean = true;
  suggestion3 = false;
  suggestion1 = false;
  suggestion2 = false;

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService,
    private obs: ObsService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.patient = this.obs._patient;
    this.obs.getPatient(this.obs._patient.patient_id).subscribe(
      (resSuccess) => {
        this.FetchPatient = resSuccess[0];
        this.form.patchValue({
          result_id: this.patient.result_id,
          first: {
            patient_id: this.patient.patient_id,
            referance_id: this.FetchPatient.ref_doct_code,
            branch_code: this.FetchPatient.Branch_Code,
            sex: this.FetchPatient.sex,
            author_id: this.FetchPatient.Author_id,
          },
          second: {
            patient_id: this.patient.patient_id,
            referance_id: this.FetchPatient.ref_doct_code,
            branch_code: this.FetchPatient.Branch_Code,
            sex: this.FetchPatient.sex,
            author_id: this.FetchPatient.Author_id,
          },
        });
        this.fetchResult();
        console.log(this.form.value);
        console.log(this.FetchPatient);
      },
      (resErr) => {}
    );

    this.obs.getDrs().subscribe(
      (resSuccess) => {
        this.drs = resSuccess;
      },
      (resErr) => {}
    );

    this.form = this.fb.group({
      result_id: [0],
      first: this.fb.group({
        fttwin1_id: [0],
        patient_id: [''],
        referance_id: [''],
        author_id: [''],
        update_author_id: [''],
        branch_code: [''],
        sex: [''],
        lmp: [''],
        ga: [''],
        edd: [''],
        no_of_fetus: [''],
        chorionicity: [''],
        amnionicity: [''],
        fetal_heart_beat: [''],
        mean_gsd: [''],
        crl: [''],
        nt_thikness: [''],
        bpd: [''],
        fl: [''],
        ac: [''],
        hc: [''],
        amniotic_fluid: [''],
        p_location: [''],
        gender: [''],
        us_average: [''],
        us_edd: [''],
        right_adnexium: [''],
        left_adnexium: [''],
        cervical_os: [''],
        efw: [''],
        other_finding: [''],
        comments: [''],
        suggestion1: [''],
        suggestion2: [''],
        suggestion3: [''],
        ftimage: [''],
        fin_year: [''],
        entry_date: [''],
        update_entry_date: [''],
        doctor_id: [''],
      }),
      second: this.fb.group({
        fttwin2_id: [0],
        patient_id: [''],
        referance_id: [''],
        author_id: [''],
        update_author_id: [''],
        branch_code: [''],
        sex: [''],
        lmp: [''],
        ga: [''],
        edd: [''],
        no_of_fetus: [''],
        chorionicity: [''],
        amnionicity: [''],
        fetal_heart_beat: [''],
        mean_gsd: [''],
        crl: [''],
        nt_thikness: [''],
        bpd: [''],
        fl: [''],
        ac: [''],
        hc: [''],
        amniotic_fluid: [''],
        p_location: [''],
        gender: [''],
        us_average: [''],
        us_edd: [''],
        right_adnexium: [''],
        left_adnexium: [''],
        cervical_os: [''],
        efw: [''],
        other_finding: [''],
        comments: [''],
        suggestion1: [''],
        suggestion2: [''],
        suggestion3: [''],
        ftimage: [''],
        fin_year: [''],
        entry_date: [''],
        update_entry_date: [''],
        doctor_id: [''],
      }),
    });
  }

  fetchResult() {
    this.obs.getFTTwin(this.patient.result_id).subscribe(
      (resSuccess) => {
        this.result = resSuccess;
        console.log(resSuccess);
        this.form.patchValue({
          first: {
            fttwin1_id: this.result.Result.first.fttwin1_id,
            lmp: this.result.Result.first.lmp,
            ga: this.result.Result.first.ga,
            edd: this.result.Result.first.edd,
            no_of_fetus: this.result.Result.first.no_of_fetus,
            chorionicity: this.result.Result.first.chorionicity,
            amnionicity: this.result.Result.first.amnionicity,
            fetal_heart_beat: this.result.Result.first.fetal_heart_beat,
            mean_gsd: this.result.Result.first.mean_gsd,
            crl: this.result.Result.first.crl,
            nt_thikness: this.result.Result.first.nt_thikness,
            bpd: this.result.Result.first.bpd,
            fl: this.result.Result.first.fl,
            ac: this.result.Result.first.ac,
            hc: this.result.Result.first.hc,
            amniotic_fluid: this.result.Result.first.amniotic_fluid,
            p_location: this.result.Result.first.p_location,
            gender: this.result.Result.first.gender,
            us_average: this.result.Result.first.us_average,
            us_edd: this.result.Result.first.us_edd,
            right_adnexium: this.result.Result.first.right_adnexium,
            left_adnexium: this.result.Result.first.left_adnexium,
            cervical_os: this.result.Result.first.cervical_os,
            efw: this.result.Result.first.efw,
            other_finding: this.result.Result.first.other_finding,
            comments: this.result.Result.first.comments,
            suggestion1: this.result.Result.first.suggestion1,
            suggestion2: this.result.Result.first.suggestion2,
            suggestion3: this.result.Result.first.suggestion3,
            ftimage: this.result.Result.first.ftimage,
            fin_year: this.result.Result.first.fin_year,
            entry_date: this.result.Result.first.entry_date,
            update_entry_date: this.result.Result.first.update_entry_date,
            doctor_id: this.result.Result.first.doctor_id,
          },
          second: {
            fttwin2_id: this.result.Result.second.fttwin2_id,
            lmp: this.result.Result.second.lmp,
            ga: this.result.Result.second.ga,
            edd: this.result.Result.second.edd,
            no_of_fetus: this.result.Result.second.no_of_fetus,
            chorionicity: this.result.Result.second.chorionicity,
            amnionicity: this.result.Result.second.amnionicity,
            fetal_heart_beat: this.result.Result.second.fetal_heart_beat,
            mean_gsd: this.result.Result.second.mean_gsd,
            crl: this.result.Result.second.crl,
            nt_thikness: this.result.Result.second.nt_thikness,
            bpd: this.result.Result.second.bpd,
            fl: this.result.Result.second.fl,
            ac: this.result.Result.second.ac,
            hc: this.result.Result.second.hc,
            amniotic_fluid: this.result.Result.second.amniotic_fluid,
            p_location: this.result.Result.second.p_location,
            gender: this.result.Result.second.gender,
            us_average: this.result.Result.second.us_average,
            us_edd: this.result.Result.second.us_edd,
            right_adnexium: this.result.Result.second.right_adnexium,
            left_adnexium: this.result.Result.second.left_adnexium,
            cervical_os: this.result.Result.second.cervical_os,
            efw: this.result.Result.second.efw,
            other_finding: this.result.Result.second.other_finding,
            comments: this.result.Result.second.comments,
            suggestion1: this.result.Result.second.suggestion1,
            suggestion2: this.result.Result.second.suggestion2,
            suggestion3: this.result.Result.second.suggestion3,
            ftimage: this.result.Result.second.ftimage,
            fin_year: this.result.Result.second.fin_year,
            entry_date: this.result.Result.second.entry_date,
            update_entry_date: this.result.Result.second.update_entry_date,
            doctor_id: this.result.Result.second.doctor_id,
          },
        });
        this.suggestion3 = JSON.parse(this.result.single.suggestion3);
        this.suggestion1 = JSON.parse(this.result.single.suggestion1);
        this.suggestion2 = JSON.parse(this.result.single.suggestion2);
        this.obs.getImage(this.result.Result.first.ftimage).subscribe(
          (resSuccess) => {
            this.fullImage = resSuccess;
            console.log(resSuccess);
            console.log(this.result.single.ftimage);
          },
          (resErr) => {}
        );
        this.obs.getImage(this.result.Result.second.ftimage).subscribe(
          (resSuccess) => {
            this.fullImage2 = resSuccess;
            console.log(resSuccess);
            console.log(this.result.single.ftimage);
          },
          (resErr) => {}
        );
        console.log(this.form.value);
      },
      (resErr) => {}
    );
  }

  getProp(prop) {
    return this[prop];
  }
  setProp(prop, value) {
    this[prop] = value;
  }

  DateChangeFirst(event: any) {
    this.form.patchValue({
      first: {
        entry_date: moment(event.target.value).format('YYYY-MM-DD'),
      },
    });
    console.log(this.form.value);
  }

  DateChangeSecond(event: any) {
    this.form.patchValue({
      second: {
        entry_date: moment(event.target.value).format('YYYY-MM-DD'),
      },
    });
    console.log(this.form.value);
  }

  slectOnChange1Single(event) {
    this.firstPic = event.value;
    this.disabled = false;
  }
  slectOnChange1Second(event) {
    this.firstPic2 = event.value;
    this.disabled2 = false;
  }

  slectOnChange(event) {
    let fullPic = this.firstPic + '/' + event.value + '.jpg';
    this.form.patchValue({
      first: {
        ftimage: fullPic,
      },
    });
    this.obs.getImage(fullPic).subscribe(
      (resSuccess) => {
        this.fullImage = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {}
    );
    console.log(this.form.value);
  }

  slectOnChangeSecond(event) {
    let fullPic = this.firstPic2 + '/' + event.value + '.jpg';
    this.form.patchValue({
      second: {
        ftimage: fullPic,
      },
    });
    this.obs.getImage(fullPic).subscribe(
      (resSuccess) => {
        this.fullImage2 = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {}
    );
    console.log(this.form.value);
  }

  onSubmit(e) {
    // e.preventDefault();
    this.form.patchValue({
      first: {
        suggestion1: this.suggestion1.toString(),
        suggestion2: this.suggestion2.toString(),
        suggestion3: this.suggestion3.toString(),
      },
      second: {
        suggestion1: this.suggestion1.toString(),
        suggestion2: this.suggestion2.toString(),
        suggestion3: this.suggestion3.toString(),
      },
    });

    this.isLoading = true;
    const { result_id, first, second } = this.form.value;
    this.obs.postFTTwins(result_id, first, second).subscribe(
      (resSuccess: []) => {
        this.response = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (this.response.success) {
          this.form.reset();
          this.isLoading = false;
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.isLoading = false;
          this._snackBar.open('Error: Please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  first() {
    this.mode = 'first';
  }
  second() {
    this.mode = 'second';
  }
}
